/**
 * sorts question options by position value
 * @param {array} options
 * @returns {array}
 */
const sortQuestionOptionsByPosition = (options) => {
  return options?.sort((a, b) => {
    return a.position - b.position;
  });
};

export default sortQuestionOptionsByPosition;
